// Spanish dictionary. Keys are the English UI strings (English = pass-through).
export const ES = {
  // Session statuses
  "completed": "completada",
  "draft": "borrador",
  "running": "en curso",
  "failed": "fallida",

  // Nav / layout
  "Dashboard": "Panel",
  "New session": "Nueva sesión",
  "Expert Agents": "Agentes expertos",
  "Marketplace": "Marketplace",
  "Billing": "Facturación",
  "Profile": "Perfil",
  "Admin": "Admin",
  "Sign out": "Cerrar sesión",
  "Loading…": "Cargando…",

  // Dashboard
  "Decision command center": "Centro de decisiones",
  "Recent sessions": "Sesiones recientes",
  "TOTAL": "TOTAL",
  "No sessions yet": "Aún no hay sesiones",
  "Start your first AI expert panel in under a minute.": "Lanza tu primer panel de expertos IA en menos de un minuto.",
  "Create decision session": "Crear sesión de decisión",
  "agents": "agentes",
  "rounds": "rondas",
  "Recommended panels": "Paneles recomendados",
  "Quick-start templates for common decisions.": "Plantillas rápidas para decisiones habituales.",
  "VAT optimization": "Optimización de IVA",
  "Pricing strategy": "Estrategia de precios",
  "Vendor selection": "Selección de proveedores",
  "Marketplace preview": "Avance del marketplace",
  "Industry packs and human expert reviews — coming soon.": "Packs por industria y revisiones de expertos humanos — muy pronto.",
  "Browse marketplace": "Explorar marketplace",
  "Saved reports": "Reportes guardados",
  "All completed decision reports live in your sessions list and can be exported as PDF.": "Todos los reportes completados están en tu lista de sesiones y pueden exportarse a PDF.",

  // Session workspace
  "Running…": "Ejecutando…",
  "Run Konzenzo": "Ejecutar Konzenzo",
  "View report": "Ver reporte",
  "Session completed": "Sesión completada",
  "Run failed": "La ejecución falló",
  "Run failed. Credits have been refunded.": "La ejecución falló. Los créditos fueron reembolsados.",
  "Running Konzenzo rounds — progress is saved, you can safely leave this page.": "Ejecutando rondas Konzenzo — el progreso se guarda, puedes salir de esta página.",
  "The last run failed. Credits were refunded — you can run the session again.": "La última ejecución falló. Los créditos fueron reembolsados — puedes ejecutar la sesión de nuevo.",
  "KONZENZO ROUNDS": "RONDAS KONZENZO",
  "ROUND": "RONDA",
  "Independent views": "Opiniones independientes",
  "Refinement": "Refinamiento",
  "Final consensus": "Consenso final",
  "running…": "ejecutando…",
  "pending": "pendiente",
  "PANEL": "PANEL",
  "Agents are deliberating…": "Los agentes están deliberando…",
  "Run the Konzenzo session to see results": "Ejecuta la sesión Konzenzo para ver resultados",
  "Round outputs appear here as soon as agents complete each phase.": "Los resultados de cada ronda aparecen aquí en cuanto los agentes completan cada fase.",

  // Create session
  "Create a decision session": "Crear una sesión de decisión",
  "Context": "Contexto",
  "Agents": "Agentes",
  "Setup": "Configuración",
  "Business challenge title": "Título del reto de negocio",
  "Describe the situation": "Describe la situación",
  "Provide as much business context as possible.": "Aporta todo el contexto de negocio posible.",
  "Business documents (optional)": "Documentos de negocio (opcional)",
  "Attach documents (PDF, DOCX, TXT, CSV)": "Adjuntar documentos (PDF, DOCX, TXT, CSV)",
  "Extracting text…": "Extrayendo texto…",
  "Up to 3 files, 5 MB each. Experts will use them as business context (+5 credits).": "Hasta 3 archivos de 5 MB. Los expertos los usarán como contexto de negocio (+5 créditos).",
  "Maximum": "Máximo",
  "documents per session": "documentos por sesión",
  "File too large. Maximum size is 5 MB.": "Archivo demasiado grande. El tamaño máximo es 5 MB.",
  "Could not process document": "No se pudo procesar el documento",
  "document truncated to fit the context limit": "documento truncado para ajustarse al límite de contexto",
  "chars": "caract.",
  "DOCUMENTS": "DOCUMENTOS",
  // Human Expert Marketplace
  "Become a Konzenzo Expert": "Conviértete en Experto Konzenzo",
  "Human Experts": "Expertos Humanos",
  "Agent Packs": "Packs de Agentes",
  "Independent human consultants who validate your Konzenzo Decision Reports. AI analyzes the decision first — human expertise validates it when needed.": "Consultores humanos independientes que validan tus Decision Reports de Konzenzo. La IA analiza la decisión primero — la experiencia humana la valida cuando es necesario.",
  "All expertise": "Toda la especialización",
  "All industries": "Todas las industrias",
  "Any availability": "Cualquier disponibilidad",
  "No experts match these filters yet": "Todavía no hay expertos con estos filtros",
  "Are you a consultant?": "¿Eres consultor?",
  "AVAILABLE": "DISPONIBLE",
  "LIMITED": "LIMITADA",
  "UNAVAILABLE": "NO DISPONIBLE",
  "DRAFT": "BORRADOR",
  "PENDING_APPROVAL": "PENDIENTE DE APROBACIÓN",
  "ACTIVE": "ACTIVO",
  "PAUSED": "PAUSADO",
  "SUSPENDED": "SUSPENDIDO",
  "REJECTED": "RECHAZADO",
  "View Profile": "Ver Perfil",
  "review": "revisión",
  "yrs": "años",
  "Approved by Konzenzo": "Aprobado por Konzenzo",
  "Expert profile": "Perfil del experto",
  "Expert not found": "Experto no encontrado",
  "Back to Marketplace": "Volver al Marketplace",
  "Expertise": "Especialización",
  "Industries": "Industrias",
  "Languages": "Idiomas",
  "Report Review service": "Servicio de Revisión de Informes",
  "Independent professional review of your Konzenzo Decision Report: assumptions challenged, additional risks, and expert recommendations.": "Revisión profesional independiente de tu Decision Report de Konzenzo: supuestos cuestionados, riesgos adicionales y recomendaciones expertas.",
  "per report review": "por revisión de informe",
  "Request Review": "Solicitar Revisión",
  "Paid reviews are launching soon — payment setup is being finalized.": "Las revisiones de pago llegan pronto — estamos finalizando la configuración de pagos.",
  "Independent professional opinion — not a Konzenzo certification.": "Opinión profesional independiente — no es una certificación de Konzenzo.",
  "Offer independent professional reviews of Konzenzo Decision Reports and get paid for your expertise. The AI analyzes the decision first — you validate it.": "Ofrece revisiones profesionales independientes de Decision Reports de Konzenzo y cobra por tu experiencia. La IA analiza la decisión primero — tú la validas.",
  "Your profile is under review by the Konzenzo team. We will notify you once approved.": "Tu perfil está siendo revisado por el equipo de Konzenzo. Te notificaremos cuando esté aprobado.",
  "Your profile is live in the Marketplace. Payment setup (Stripe) will be available soon.": "Tu perfil está publicado en el Marketplace. La configuración de pagos (Stripe) estará disponible pronto.",
  "First name": "Nombre",
  "Last name": "Apellidos",
  "City (optional)": "Ciudad (opcional)",
  "Professional headline": "Titular profesional",
  "Professional bio": "Biografía profesional",
  "Years of experience": "Años de experiencia",
  "Current role (optional)": "Cargo actual (opcional)",
  "Primary expertise": "Especialización principal",
  "e.g., CFO advisor for manufacturing SMEs": "ej., Asesor CFO para pymes industriales",
  "Dark = primary (max 3), light blue = secondary (max 10). Click to cycle.": "Oscuro = principal (máx 3), azul claro = secundaria (máx 10). Haz clic para alternar.",
  "Add language": "Añadir idioma",
  "Availability": "Disponibilidad",
  "Turnaround": "Plazo de entrega",
  "Price per review": "Precio por revisión",
  "Service description": "Descripción del servicio",
  "I accept the Konzenzo Marketplace Terms: independent professional relationship, confidentiality of shared reports, marketplace commission on paid reviews, and professional responsibility for my opinions.": "Acepto los Términos del Marketplace de Konzenzo: relación profesional independiente, confidencialidad de los informes compartidos, comisión del marketplace en revisiones de pago y responsabilidad profesional sobre mis opiniones.",
  "Save draft": "Guardar borrador",
  "Saving…": "Guardando…",
  "Submit for approval": "Enviar para aprobación",
  "Profile saved": "Perfil guardado",
  "Profile submitted for approval": "Perfil enviado para aprobación",
  "Save failed": "Error al guardar",
  "Get a Human Expert Review": "Obtén una Revisión de Experto Humano",
  "Add an independent human perspective to challenge the assumptions, risks and recommendations generated through the Konzenzo analysis.": "Añade una perspectiva humana independiente para cuestionar los supuestos, riesgos y recomendaciones generados por el análisis Konzenzo.",
  "Browse All Experts": "Ver Todos los Expertos",
  // Fase 2 — Connect + reviews
  "Expert dashboard": "Panel de experto",
  "Edit profile": "Editar perfil",
  "Payments setup": "Configuración de pagos",
  "Marketplace payments are not enabled on this environment yet.": "Los pagos del marketplace aún no están habilitados en este entorno.",
  "Your Stripe account is ready to receive payments.": "Tu cuenta de Stripe está lista para recibir pagos.",
  "Complete the Stripe onboarding to receive paid review requests.": "Completa el onboarding de Stripe para recibir solicitudes de revisión de pago.",
  "Set up payments": "Configurar pagos",
  "Continue onboarding": "Continuar onboarding",
  "Reviews sold": "Revisiones vendidas",
  "Gross": "Bruto",
  "Konzenzo fee": "Comisión Konzenzo",
  "Your earnings": "Tus ingresos",
  "Review requests": "Solicitudes de revisión",
  "No review requests yet. Make sure your payments setup is complete and your availability is on.": "Aún no hay solicitudes. Asegúrate de completar la configuración de pagos y estar disponible.",
  "You earn": "Ganas",
  "Accept": "Aceptar",
  "Decline": "Rechazar",
  "Request accepted — the customer will be asked to pay": "Solicitud aceptada — se pedirá el pago al cliente",
  "Request declined": "Solicitud rechazada",
  "Could not start onboarding": "No se pudo iniciar el onboarding",
  "Refresh": "Actualizar",
  "My expert reviews": "Mis revisiones de expertos",
  "No expert reviews requested yet": "Aún no has solicitado revisiones de expertos",
  "Open a completed Decision Report and request a human expert review.": "Abre un Decision Report completado y solicita una revisión de experto humano.",
  "Complete Payment": "Completar Pago",
  "Waiting for the expert to accept": "Esperando a que el experto acepte",
  "Payment confirmed — the expert review is now in progress": "Pago confirmado — la revisión del experto está en curso",
  "Could not start payment": "No se pudo iniciar el pago",
  "Which Decision Report should be reviewed?": "¿Qué Decision Report debe revisarse?",
  "You need a completed Decision Report first.": "Primero necesitas un Decision Report completado.",
  "You will only pay after the expert accepts. Free cancellation before payment.": "Solo pagarás cuando el experto acepte. Cancelación gratuita antes del pago.",
  "Send request": "Enviar solicitud",
  "Sending…": "Enviando…",
  "Review requested — we'll notify you when the expert accepts": "Revisión solicitada — te avisaremos cuando el experto acepte",
  "Could not request review": "No se pudo solicitar la revisión",
  "This expert is finalizing their payment setup — check back soon.": "Este experto está finalizando su configuración de pagos — vuelve pronto.",
  "Your profile is live in the Marketplace.": "Tu perfil está publicado en el Marketplace.",
  "Go to Expert dashboard": "Ir al Panel de experto",
  "REQUESTED": "SOLICITADA",
  "ACCEPTED_AWAITING_PAYMENT": "ACEPTADA — PENDIENTE DE PAGO",
  "IN_REVIEW": "EN REVISIÓN",
  "DELIVERED": "ENTREGADA",
  "COMPLETED": "COMPLETADA",
  "DECLINED": "RECHAZADA",
  "EXPIRED": "EXPIRADA",
  "CANCELLED": "CANCELADA",
  "Industry": "Industria",
  "Country / jurisdiction": "País / jurisdicción",
  "Company size": "Tamaño de empresa",
  "Urgency": "Urgencia",
  "Desired outcome": "Resultado deseado",
  "Confidentiality": "Confidencialidad",
  "Next: select agents": "Siguiente: elegir agentes",
  "Select your expert panel": "Elige tu panel de expertos",
  "Pick at least one. Recommended panels coming next iteration.": "Elige al menos uno.",
  "SELECTED": "SELECCIONADOS",
  "Back": "Atrás",
  "Next: setup": "Siguiente: configuración",
  "Number of Konzenzo rounds": "Número de rondas Konzenzo",
  "1 round (quick)": "1 ronda (rápida)",
  "2 rounds (standard)": "2 rondas (estándar)",
  "3 rounds (deep)": "3 rondas (profunda)",
  "Depth of analysis": "Profundidad del análisis",
  "Output format": "Formato de salida",
  "Executive summary": "Resumen ejecutivo",
  "Detailed report": "Reporte detallado",
  "Action plan": "Plan de acción",
  "Risk sensitivity": "Sensibilidad al riesgo",
  "Konzenzo agents provide structured analysis to support — not replace — qualified human review for tax, legal and financial matters.": "Los agentes de Konzenzo ofrecen análisis estructurado para apoyar — no reemplazar — la revisión humana cualificada en materias fiscales, legales y financieras.",
  "Review credit cost": "Revisar coste en créditos",
  "Session created. Running Konzenzo rounds…": "Sesión creada. Ejecutando rondas Konzenzo…",
  "Could not create session": "No se pudo crear la sesión",
  "low": "baja",
  "standard": "estándar",
  "high": "alta",
  "medium": "media",
  "quick": "rápida",
  "deep": "profunda",
  "sensitive": "sensible",
  "highly confidential": "altamente confidencial",

  // Credit estimate dialog
  "Confirm Konzenzo session": "Confirmar sesión Konzenzo",
  "Calculating cost…": "Calculando coste…",
  "Could not calculate the session cost. Check your connection and try again.": "No se pudo calcular el coste de la sesión. Comprueba tu conexión e inténtalo de nuevo.",
  "Retry": "Reintentar",
  "Total": "Total",
  "credits": "créditos",
  "Current balance": "Saldo actual",
  "After this run": "Después de esta ejecución",
  "This session requires the": "Esta sesión requiere el plan",
  "plan or higher.": "o superior.",
  "Insufficient credits. Buy a credit pack or upgrade your plan in the Billing page.": "Créditos insuficientes. Compra un pack de créditos o mejora tu plan en Facturación.",
  "Konzenzo provides AI-assisted decision support. Outputs may be inaccurate; validate before acting.": "Konzenzo ofrece apoyo a decisiones asistido por IA. Los resultados pueden ser imprecisos; valídalos antes de actuar.",
  "Cancel": "Cancelar",
  "Run for": "Ejecutar por",

  // Report
  "Decision report": "Reporte de decisión",
  "Workspace": "Espacio de trabajo",
  "Send to advisor": "Enviar a asesor",
  "Export PDF": "Exportar PDF",
  "CONFIDENCE": "CONFIANZA",
  "Consensus recommendation": "Recomendación de consenso",
  "Business context": "Contexto de negocio",
  "Desired outcome: ": "Resultado deseado: ",
  "Experts involved": "Expertos involucrados",
  "Areas of agreement": "Puntos de acuerdo",
  "Areas of disagreement": "Puntos de desacuerdo",
  "Risks & mitigations": "Riesgos y mitigaciones",
  "Open questions": "Preguntas abiertas",
  "Final-round agent recommendations": "Recomendaciones finales de los agentes",
  "Suggested next expert review": "Próxima revisión experta sugerida",
  "Konzenzo provides structured AI analysis to support — not replace — qualified human review for tax, legal and financial matters.": "Konzenzo ofrece análisis IA estructurado para apoyar — no reemplazar — la revisión humana cualificada en materias fiscales, legales y financieras.",

  // Share dialog
  "Send to your advisor": "Envíalo a tu asesor",
  "Recipient email": "Email del destinatario",
  "Name (optional)": "Nombre (opcional)",
  "Note (optional)": "Nota (opcional)",
  "Link expires in": "El enlace caduca en",
  "days": "días",
  "The recipient gets a unique, read-only link. They cannot edit your report or trigger new sessions.": "El destinatario recibe un enlace único de solo lectura. No puede editar tu reporte ni lanzar nuevas sesiones.",
  "Sending…": "Enviando…",
  "Send report": "Enviar reporte",
  "Review link generated": "Enlace de revisión generado",
  "Done": "Listo",
  "Please enter a valid email": "Introduce un email válido",
  "Link copied": "Enlace copiado",
  "Could not share": "No se pudo compartir",

  // Billing
  "Billing & credits": "Facturación y créditos",
  "CURRENT PLAN": "PLAN ACTUAL",
  "Custom pricing": "Precio a medida",
  "user": "usuario",
  "users": "usuarios",
  "Monthly credit usage": "Uso de créditos mensuales",
  "used": "usados",
  "Resets": "Se renueva el",
  "Usage history": "Historial de uso",
  "ENTRIES": "MOVIMIENTOS",
  "No transactions yet.": "Aún no hay movimientos.",
  "Payment history": "Historial de pagos",
  "PAYMENTS": "PAGOS",
  "No payments yet.": "Aún no hay pagos.",
  "CURRENT BALANCE": "SALDO ACTUAL",
  "credits available": "créditos disponibles",
  "Monthly": "Mensuales",
  "Purchased": "Comprados",
  "Buy credit packs": "Comprar packs de créditos",
  "12-month validity": "válido 12 meses",
  "VAT calculated by Stripe Tax at checkout · Secure payment via Stripe": "IVA calculado por Stripe Tax al pagar · Pago seguro vía Stripe",
  "Subscription plans": "Planes de suscripción",
  "Monthly recurring billing via Stripe. Cancel anytime.": "Pago recurrente mensual vía Stripe. Cancela cuando quieras.",
  "cr/mo": "cr/mes",
  "Custom credits": "Créditos a medida",
  "Subscribe": "Suscribirse",
  "Current plan": "Plan actual",
  "Contact us": "Contáctanos",
  "ACTIVE SUBSCRIPTION": "SUSCRIPCIÓN ACTIVA",
  "Renews": "Se renueva el",
  "Cancels at period end": "Se cancela al final del periodo",
  "Cancel subscription": "Cancelar suscripción",
  "Cancelling…": "Cancelando…",
  "Your subscription will end at the current period end. You keep your credits until then.": "Tu suscripción terminará al final del periodo actual. Conservas tus créditos hasta entonces.",
  "Subscription set to cancel at period end": "La suscripción se cancelará al final del periodo",
  "Could not start checkout.": "No se pudo iniciar el pago.",
  "Could not cancel": "No se pudo cancelar",
  "Monthly plan credits": "Créditos mensuales del plan",
  "Konzenzo session": "Sesión Konzenzo",
  "Refund (failed session)": "Reembolso (sesión fallida)",
  "Credit pack purchase": "Compra de pack de créditos",
  "Auto top-up": "Recarga automática",
  "Credit expiration": "Caducidad de créditos",
  "Manual adjustment": "Ajuste manual",
  "PAID": "PAGADO",
  "PENDING": "PENDIENTE",
  "Konzenzo provides AI-assisted analysis to support — not replace — qualified human review for tax, legal and financial matters. Final decisions remain the sole responsibility of you and your organization.": "Konzenzo ofrece análisis asistido por IA para apoyar — no reemplazar — la revisión humana cualificada en materias fiscales, legales y financieras. Las decisiones finales son responsabilidad exclusiva tuya y de tu organización.",

  // Billing success / cancel
  "Payment confirmation": "Confirmación de pago",
  "Confirming your payment…": "Confirmando tu pago…",
  "Stripe is finalizing the transaction. Credits are applied only after the verified webhook completes.": "Stripe está finalizando la transacción. Los créditos se aplican solo tras verificarse el webhook.",
  "ATTEMPT": "INTENTO",
  "Payment successful": "Pago realizado",
  "CREDITS ADDED": "CRÉDITOS AÑADIDOS",
  "New balance:": "Nuevo saldo:",
  "Back to billing": "Volver a facturación",
  "Go to dashboard": "Ir al panel",
  "Still processing…": "Aún procesando…",
  "Stripe is taking longer than usual to confirm. Your credits will appear as soon as the payment is verified.": "Stripe está tardando más de lo habitual. Tus créditos aparecerán en cuanto se verifique el pago.",
  "View billing": "Ver facturación",
  "We could not confirm your payment": "No pudimos confirmar tu pago",
  "Payment cancelled": "Pago cancelado",
  "No charge was made. You can pick a different credit pack or come back later.": "No se realizó ningún cargo. Puedes elegir otro pack de créditos o volver más tarde.",

  // Agents catalog / marketplace
  "Expert agents catalog": "Catálogo de agentes expertos",
  "Each agent has a defined persona, scope and analysis style. Mix and match to match your decision.": "Cada agente tiene una personalidad, alcance y estilo de análisis definidos. Combínalos según tu decisión.",
  "When to use: ": "Cuándo usarlo: ",
  "Analysis: ": "Análisis: ",
  "Coming soon": "Muy pronto",
  "Browse industry-specific agent packs and human-certified expert reviews. The marketplace launches with the full Konzenzo expert ecosystem.": "Explora packs de agentes por industria y revisiones certificadas por expertos humanos. El marketplace llegará con todo el ecosistema Konzenzo.",

  // Profile
  "Company profile": "Perfil de empresa",
  "Company name": "Nombre de la empresa",
  "Preferred language": "Idioma preferido",
  "Saving…": "Guardando…",
  "Save profile": "Guardar perfil",
  "Profile saved": "Perfil guardado",
  "Could not save": "No se pudo guardar",
};
